<template>
  <!-- Registered card -->
  <div @click="showAttendees" class="col pe-2">
    <div class="stats-card">
      <img
        v-if="IsRegistered"
        src="../assets/images/event/icon-registered.svg"
        alt="Registered"
        class="stats-card__img"
      />
      <img
        v-if="!IsRegistered"
        src="../assets/images/event/icon-checkedin.svg"
        alt="Checked-in"
        class="stats-card__img"
      />
      <div>
        <div v-if="IsRegistered" class="big-number">
          {{ EventStats.Registered }}
        </div>
        <div v-if="!IsRegistered" class="big-number">
          {{ EventStats.Present ?? EventStats.Attended }}
        </div>
        <div v-if="IsRegistered" class="big-number-label">registered</div>
        <div v-if="!IsRegistered" class="big-number-label">checked-in</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventStatsComponent",
  props: {
    EventStats: Object,
    IsRegistered: Boolean,
  },
  emits: ["showRegisteredAttendees", "showCheckedInAttendees"],
  methods: {
    showAttendees() {
      if (this.IsRegistered) this.$emit("showRegisteredAttendees");
      else this.$emit("showCheckedInAttendees");
    },
  },
};
</script>
